import { FiltersData, StateObj, FilterCalendar, EventsObj, FilterState, CalendarEvent, CalendarViewType } from '../../helpers/Calendar-Interfaces'
import {
    getUrlParams, getDefaultFilters, getEvents, getParamsObjFromState, showTags, updateCalendarTags,
    updateUrlParams, initFilterState, addTagsToState, matchesFilters, generateDateObj, updateCalendarView,
    updateFilterCalendarState, doesEventIntersectWithMonth
} from '../../helpers/Calendar-helper';
import { EventsFullCalendar } from '../calendar/fullCalendar';
var moment = require('moment');
import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.css';
import { Modal } from '../../classes/modal';

export class CalendatNewFile {
    minDateLimit: Date | null;
    maxDateLimit: Date | null;
    // Earliest date authors allow navigating to (from "Months to look in the Past").
    // Null means no author-set limit, keeping the default 12-month behaviour.
    pastLimit: Date | null;

    defaultFilters: { all: FiltersData; default: FiltersData; params: StateObj };
    datePicker;

    events: EventsObj = { all: null, filtered: [], month: [], loadedMonth: [] };
    filterState: FilterState
    tagsToView: Array<FilterCalendar> = [];
    availableTags: Array<number>;
    tagsCheckboxes = [].slice.call(document.getElementsByName('tags'))

    calendarEl: HTMLElement = document.getElementById('calendar');
    fullCalendar: EventsFullCalendar;
    calendarViewMode: CalendarViewType;

    eventModal: Modal;
    eventModalContentArea: HTMLElement;

    clickTimeout;
    clickThreshold = 500; // Adjust this value to set the threshold for fast clicks in milliseconds

    fetchAllEvents: boolean;

    searchEvents: string;

    constructor() {
        this.defaultFilters = {
            all: getDefaultFilters(true),
            default: getDefaultFilters(),
            params: getUrlParams(getDefaultFilters())
        }

        this.filterState = initFilterState(this.defaultFilters.params)

        const tags = document.getElementById('avaliable-tags') as HTMLInputElement;
        this.availableTags = tags ? tags.value.split(',').map(i => parseInt(i)) : []
        this.updateFiltersView();
        this.datePicker = this.initFpDatepicker(); // Init datepicker
        this.fetchAllEvents = false;

        /* Set date from urlSearch params to datepicker */
        const { date } = this.filterState;
        if (date && date.full) {
            if (date.day) {
                this.datePicker.setDate(date.full);
            } else {
                const { year, month } = date;
                if (year) {
                    month && this.datePicker.changeMonth(Number(month) - 1, false);
                    this.datePicker.changeYear(year, false);
                }
            }
        }
        /* ----------------------------------------- */

        // Read the author-configured past limit (rendered by the CalendarPage view).
        // When set, it caps how far back visitors can navigate; otherwise the
        // calendar keeps showing up to 12 months of past events.
        const prevLimiterEl = document.getElementById('PrevMonthlimiter');
        const prevLimiterValue = prevLimiterEl ? prevLimiterEl.textContent.trim() : '';
        this.pastLimit = prevLimiterValue ? new Date(prevLimiterValue) : null;
        if (this.pastLimit && !isNaN(this.pastLimit.getTime())) {
            this.minDateLimit = this.pastLimit;
        } else {
            this.pastLimit = null;
        }

        this.fullCalendar = new EventsFullCalendar(this.calendarEl, this.minDateLimit);

        const modalElement = document.querySelector('#Event_modal') as HTMLElement;
        this.eventModal = new Modal(modalElement);
        this.eventModalContentArea = modalElement.querySelector('#Event_modal_content') as HTMLElement;

        document.addEventListener('click', this.pageClick.bind(this));
    }

    /**
      * Initializes the application by fetching events for the current month,
      * updating the state, filtering events, and setting up event handlers.
      */
    init() {
        // Determine the current date, start, and end of the month
        const currentDate = this.filterState.date ? this.filterState.date.full : new Date();
        this.getAllEvents(currentDate, this.defaultFilters.params);
        this.getAllEvents(null, this.defaultFilters.params);

        // Set up event handlers
        this.handleCalendarFilterCheckboxClick();  // On calendar filter click event
        this.handleResetButtonClick();  // On reset button click event

         // Add a click event listener to the 'mNav_today' button
        const todayBtn = document.getElementById('mNav_today');
        todayBtn.addEventListener('click', () => {
            this.datePicker.setDate(new Date().setHours(0, 0, 0, 0), true);

        });

        // Update Filter calendars checked inpunts
        updateCalendarView(this.filterState.filters)

        this.eventSearch();
        this.resetEventSearch();
    }
    

    initFpDatepicker() {
        let miniCalendar = document.getElementById('fpCalendar');
        const generateDateStr = (ins) => { return `${ins.currentYear}-${ins.currentMonth}` }
        let inst: string;
        let lastChangedEvent: 'onChange' | 'onMonthChange' | 'onYearChange';
        return flatpickr(miniCalendar, {
            inline: true,
            monthSelectorType: 'static',
            onReady: (selectedDates, dateStr, instance) => {
                inst = generateDateStr(instance);
            },
            onChange: (selectedDates, dateStr, instance) => {
                
                /**
                 * Handles the selection and deselection of a date in the date picker.
                 *
                 * @param selectedDate - The selected date.
                 * @param instance - The flatpickr instance.
                 */
                const handleDateSelection = (selectedDate: Date, instance: any) => {
                    // Check if a date is already selected and matches the clicked date
                    if (this.filterState.date && selectedDate.getTime() === this.filterState.date.full.getTime()) {
                        // Unselect the date
                        this.filterState.date = null;
                        instance.selectedDates = [];

                        // Remove the 'selected' class from the UI element representing the selected date
                        const selected = document.querySelector('.selected');
                        if (selected) {
                            selected.classList.remove('selected');
                        }
                    } else {
                        // Select a new date
                        this.filterState.date = generateDateObj(selectedDate);
                    }

                    // Update URL parameters based on the filter state
                    updateUrlParams(getParamsObjFromState(this.filterState));
                };
               
                handleDateSelection(selectedDates[0], instance);

                if (!lastChangedEvent || lastChangedEvent === 'onChange') {
                    const dateToCalendar = this.filterState.date && this.filterState.date.full ? this.filterState.date.full : new Date(instance.currentYear, instance.currentMonth);
                    this.fullCalendar.updateEventSource(this.events);
                    this.fullCalendar.calendarView(this.fullCalendar.getCalendarView(this.filterState), dateToCalendar);
                    this.fullCalendar.showInfoMessage();
                    this.fullCalendar.renderCalendar();
                } 
                lastChangedEvent = 'onChange';

            },
            onMonthChange: (selectedDates, dateStr, instance) => {
                lastChangedEvent = 'onMonthChange';

                if (selectedDates && selectedDates.length > 0) {
                    const instDate = generateDateStr(instance);
                    const selectedDate = generateDateStr({
                        currentYear: selectedDates[0].getFullYear(),
                        currentMonth: selectedDates[0].getMonth()
                    });

                    // Check if the instance date and selected date are different
                    if (instDate !== selectedDate) {
                        // Clear selectedDates and redraw the datePickerSS
                        this.datePicker.selectedDates = [];
                        this.datePicker.redraw();
                        lastChangedEvent = 'onChange';
                    }
                } else {
                    lastChangedEvent = 'onChange';
                }

                if (inst === generateDateStr(instance)) {
                    return;
                } else {
                    inst = generateDateStr(instance);

                    this.filterState.date = null;
                    updateUrlParams(getParamsObjFromState(this.filterState));
                
                    // Clear the previous timeout
                    clearTimeout(this.clickTimeout);
                    this.clickTimeout = setTimeout(() => {
                        this.getAllEvents(new Date(instance.currentYear, instance.currentMonth))
                    }, this.clickThreshold);
                }
            },
            onYearChange: (selectedDates, dateStr, instance) => {
                inst = generateDateStr(instance);

                this.filterState.date = null;
                updateUrlParams(getParamsObjFromState(this.filterState))

                // Clear the previous timeout
                clearTimeout(this.clickTimeout);
                this.clickTimeout = setTimeout(() => {
                    this.getAllEvents(new Date(instance.currentYear, instance.currentMonth))
                }, this.clickThreshold);
            }
        })
    }

    /**
     * Fetches events for the specified month, processes and updates the application state.
     *
     * @param date - The date within the target month.
     */
    getAllEvents(date: Date | null, params?: StateObj) {
        // Calculate the start and end dates of the month
        const dateStart: Date | null = date ? moment(date).startOf('month').toDate(): null;
        const dateEnd: Date | null = date ? moment(date).endOf('month').toDate() : null;
        let isChangedView: boolean = false;
        const paramsObj = params ? params : getParamsObjFromState(this.filterState);

        const updateView = () => {
            this.checkNextMonthBtn();

            // Update the filters view based on the modified state
            this.updateFiltersView();

            // Add markers to the datepicker based on the filtered events
            this.addDatepickerMarkers(this.events.filtered);

            // Update the fullCalendar UI components
            const dateToCalendar = this.filterState.date && this.filterState.date.full
                ? this.filterState.date.full
                : new Date(this.datePicker.currentYear, this.datePicker.currentMonth);

            this.fullCalendar.updateEventSource(this.events);
            this.fullCalendar.calendarView(this.fullCalendar.getCalendarView(this.filterState), dateToCalendar);
            this.fullCalendar.renderCalendar();
            this.fullCalendar.showInfoMessage();
        }
        const generateDateStr = (date: Date) => { return `${date.getFullYear()}-${date.getMonth()}` };

        if (this.fetchAllEvents) {
            // Every event is already on the client at this point, so the month view
            // must be rebuilt for any target month — gating on loadedMonth skipped
            // months where no event starts, leaving the calendar stuck.
            if (date) {
                this.events.month = [];

                if (this.filterState.filters && this.filterState.filters.length) {
                    this.filterState.filters.forEach(calendar => {
                        calendar.tags.forEach(tag => tag.count = 0);
                    })
                }
                this.events.all.forEach(event => {

                    if (doesEventIntersectWithMonth(event, dateStart.getTime(), dateEnd.getTime())) {
                        // Add the event to the array of events for the selected month
                        this.events.month.push(event);
                        addTagsToState(this.filterState, event, paramsObj.tags, this.availableTags);

                    }
                });

                /*if (this.filterState.filters && this.filterState.filters.length) {
                   this.filterState.filters.forEach(calendar => {
                       calendar.tags.forEach(tag => tag.isChecked = tag.isChecked && tag.count === 0 ? false : tag.isChecked);
                   })
               }*/

                updateView();
                isChangedView = true;
            }
        } else {
            if (date) {
                // Show Loading 
                this.fullCalendar.showLoading(true)
            }
            
            // Fetch events for the current month from the data source (e.g., API)
            getEvents(dateStart, dateEnd, this.defaultFilters.all.calendars).then(data => {
                // Store all events in the 'events.all' array
                this.events.all = data.calendarEvents;
                this.events.filtered = [];
                this.events.month = [];
                this.events.loadedMonth = [];

                if ((dateStart && dateEnd) && this.filterState.filters && this.filterState.filters.length) {
                    this.filterState.filters.forEach(calendar => {
                        calendar.tags.forEach(tag => tag.count = 0);
                    })
                }
                this.events.all.forEach(event => {

                    if (dateStart && dateEnd && doesEventIntersectWithMonth(event, dateStart.getTime(), dateEnd.getTime())) {
                        // Add the event to the array of events for the selected month
                        this.events.month.push(event);

                        // Add tags to the state and filter events based on current parameters
                        addTagsToState(this.filterState, event, paramsObj.tags, this.availableTags);
                    }

                    if (!dateStart && !dateEnd) {
                        const convertedDateStart = generateDateStr(new Date(event.start));
                        const convertedDateEnd = generateDateStr(new Date(event.end));
                        if (!this.events.loadedMonth.includes(convertedDateStart)) this.events.loadedMonth.push(convertedDateStart);
                        if (!this.events.loadedMonth.includes(convertedDateEnd)) this.events.loadedMonth.push(convertedDateEnd);

                        if (!this.pastLimit && (!this.minDateLimit || this.minDateLimit.getTime() > new Date(event.start).getTime())) { this.minDateLimit = new Date(event.start) }
                        if (!this.maxDateLimit || this.maxDateLimit.getTime() < new Date(event.end).getTime()) { this.maxDateLimit = new Date(event.end) }
                    }

                });

                // check if default tags assined to calendars
                const checkParamsTag = (params: StateObj, state: FilterState): StateObj => {
                    const returnParams: StateObj = {
                        calendars: params.calendars.length > 0 ? [...params.calendars] : [],
                        date: params.date,
                        tags: []
                    }
                    if (params.tags.length > 0 && params.calendars.length > 0) {
                        const defaultCalendars = state.filters.filter(calendar => params.calendars.includes(calendar.calendarID))

                        defaultCalendars.forEach(calendar => {
                            calendar.tags.forEach(tag => {
                                params.tags.includes(tag.tagID) && returnParams.tags.push(tag.tagID)
                            })
                        })

                    }
                    return returnParams
                }
                
                this.events.all.forEach(event => {
                    matchesFilters(event, getParamsObjFromState(this.filterState)) && this.events.filtered.push(event);
                })
                /* if (this.filterState.filters && this.filterState.filters.length) {
                     this.filterState.filters.forEach(calendar => {
                         calendar.tags.forEach(tag => tag.isChecked = tag.isChecked && tag.count === 0 ? false : tag.isChecked);
                     })
                 }*/

                if (dateStart && dateEnd) {
                    if (!isChangedView) {
                        updateView();
                    } else {
                        // Add markers to the datepicker based on the filtered events
                        this.addDatepickerMarkers(this.events.filtered);
                    }
                } else {
                    this.fetchAllEvents = true;

                    // Keep today's month reachable when the first event is later, and stop
                    // flatpickr's set('minDate'/'maxDate') from jumping the view off the
                    // current month (it auto-jumps to minDate when minDate is in the future).
                    const today = moment().startOf('day').toDate();
                    const pickerMinDate = this.minDateLimit && this.minDateLimit.getTime() < today.getTime()
                        ? this.minDateLimit
                        : today;
                    this.datePicker.set('minDate', pickerMinDate)
                    this.datePicker.set('maxDate', this.maxDateLimit)

                    const viewDate = this.filterState.date && this.filterState.date.full
                        ? this.filterState.date.full
                        : new Date();
                    this.datePicker.jumpToDate(viewDate, false);
                }

            }).catch(error => {
                if (dateStart && dateEnd) { this.fullCalendar.showMessage(true, 'Failed to fetch events') }
            });
        }
    }

    /**
     * Handles the click event on calendar filter checkboxes.
     * Updates the filter state, parameters, filters view, and filtered events based on the selected calendar.
     */
    handleCalendarFilterCheckboxClick() {
        // Get all calendar filter checkboxes
        const calendarsFilter = Array.from(document.getElementsByName('categories') as NodeListOf<HTMLInputElement>);

        // Add click event listener to each calendar filter checkbox
        calendarsFilter.forEach(calendar => {
            calendar.addEventListener('click', (event) => {
                // Find the calendar in the filter state based on the clicked checkbox value
                const calendar = this.filterState.filters.find(i => i.calendarID === Number(event.target['value']));

                // Update calendar tags based on the checkbox state
                updateCalendarTags(calendar, event.target['checked']);

                // Filters logic
                this.updateFiltersView();

                // Filter events based on updated parameters
                this.events.filtered = this.events.all.filter(event => matchesFilters(event, getParamsObjFromState(this.filterState)));

                // Filter events based on search events input
                this.events.filtered = this.checkSearchEvents(this.events.filtered, this.searchEvents);

                // Update datePicker markers
                this.addDatepickerMarkers(this.events.filtered)

                // Update fullCalendar
                this.fullCalendar.updateEventSource(this.events);
                this.fullCalendar.renderCalendar();
                this.fullCalendar.showInfoMessage();
            });
        });
    }

    /**
     * Adds event listeners to tag checkboxes for filtering events based on selected tags.
     * Updates calendar data and triggers event filtering on checkbox click.
     * 
     * @param calendars - Array of calendars with associated tags.
     * @param params - Object containing filter parameters.
     */
    tagsEventListener() {
        // Get all tag checkboxes
        const tagCheckboxes = Array.from(document.getElementsByName('tags')) as HTMLInputElement[];

        // Add click event listener to each tag checkbox
        tagCheckboxes.forEach(tagCheckbox => {
            tagCheckbox.addEventListener('click', (event) => {
                // Extract tag information from the clicked checkbox
                const clickedTagId: number = Number(event.target['value']);
                const associatedCalendar: FilterCalendar | undefined = this.filterState.filters.find(calendar =>
                    calendar.tags.some(tag => tag.tagID === clickedTagId)
                );

                // Update the isChecked property of the clicked tag
                if (associatedCalendar) {
                    const clickedTag = associatedCalendar.tags.find(tag => tag.tagID === clickedTagId);
                    if (clickedTag) {
                        clickedTag.isChecked = event.target['checked'];
                    }
                }
                const params = getParamsObjFromState(this.filterState)
                // Update URL parameters
                updateUrlParams(params);

                // Filter events based on updated parameters
                this.events.filtered = this.events.all.filter(event => matchesFilters(event, params));

                // Filter events based on search events input
                this.events.filtered = this.checkSearchEvents(this.events.filtered, this.searchEvents);

                // Add markers to the datepicker based on filtered events
                this.addDatepickerMarkers(this.events.filtered);

                // Update fullCalendar
                this.fullCalendar.updateEventSource(this.events);
                this.fullCalendar.renderCalendar();
                this.fullCalendar.showInfoMessage();
            });
        });
    }

    /**
     * Handles the logic when the reset button is clicked.
     * Resets filters to default values, updates view checkboxes, filters events, and updates associated components.
     */
    handleResetButtonClick() {
        // Get the reset button by its ID
        const resetBtn = document.getElementById('mNav_ResetCat');

        // Add click event listener to the reset button
        resetBtn.addEventListener('click', () => {

            // Update filterState.filters based on the reset parameters
            this.filterState.filters.forEach(calendar => {
                calendar.isChecked = this.defaultFilters.default.calendars.some(id => id == calendar.calendarID);
                calendar.tags.forEach(tag => {
                    tag.isChecked = tag.isChecked ? this.defaultFilters.default.tags.some(id => id == tag.tagID) : false;
                });
            });

            // Clear any selected day so the reset also unselects the mini calendar
            this.filterState.date = null;
            this.datePicker.selectedDates = [];
            const selectedDay = document.querySelector('.selected');
            if (selectedDay) {
                selectedDay.classList.remove('selected');
            }

            // Update calendar and tags view checkboxes
            const categoriesCheckBoxes = Array.from(document.getElementsByName('categories') as NodeListOf<HTMLInputElement>);
            categoriesCheckBoxes.forEach(calendar => {
                calendar.checked = this.defaultFilters.default.calendars.some(id => id == Number(calendar.value));
            });

            // Update filters view
           this.updateFiltersView();

            // Reset filtered events array and filter events based on the new parameters
            this.events.filtered = [];
            const params = getParamsObjFromState(this.filterState)
            this.events.all.forEach(event => {
                matchesFilters(event, params) && this.events.filtered.push(event);
            });
            // Update fpDatepicker markers (redraws the mini calendar without the selection)
            this.addDatepickerMarkers(this.events.filtered);

            // Update fullCalendar and navigate back to the currently shown month
            const dateToCalendar = this.filterState.date && this.filterState.date.full
                ? this.filterState.date.full
                : new Date(this.datePicker.currentYear, this.datePicker.currentMonth);
            this.fullCalendar.updateEventSource(this.events);
            this.fullCalendar.calendarView(this.fullCalendar.getCalendarView(this.filterState), dateToCalendar);
            this.fullCalendar.renderCalendar();
            this.fullCalendar.showInfoMessage();
        });
    }

    /**
     * Adds markers to the Flatpickr date picker based on provided events.
     * Marks dates with events and highlights the currently selected date.
     * @param {Array} events - An array of events containing start and end dates.
     */
    addDatepickerMarkers(events: CalendarEvent[]) {
        // Array to store dates with events
        const selectedDays = [];

        /**
         * Generates an array of dates between start_date and end_date.
         * @param {string} start_date - The start date in "YYYY-MM-DD" format.
         * @param {string} end_date - The end date in "YYYY-MM-DD" format.
         * @param {string} date_format - The format of the date (default is "YYYY-MM-DD").
         * @returns {Array} - An array of dates between start_date and end_date.
         */
        const getRangeOfDates = (start_date, end_date, date_format = "YYYY-MM-DD") => {
            // Helper function to convert date to moment.js object
            const getDateAsArray = date => moment(date.split(/\D+/), date_format);
            const diff = getDateAsArray(end_date).diff(getDateAsArray(start_date), "days") + 1;
            const dates = [];
            for (let i = 0; i < diff; i++) {
                const nextDate = getDateAsArray(start_date).add(i, "day");
                dates.push(nextDate.format(date_format));
            }
            return dates;
        };

        // Process each event and populate selectedDays array
        events.forEach(event => {
            const start = moment(event.extendedProps.eventStartDate).format('YYYY-MM-DD');
            const end = event.extendedProps.Duration === "All Day"
                ? moment(event.extendedProps.eventStartDate).format('YYYY-MM-DD')
                : moment(event.extendedProps.eventEndDate).format('YYYY-MM-DD');
            selectedDays.push(...getRangeOfDates(start, end));
        });

        // Set the onDayCreate callback for Flatpickr to customize day elements
        this.datePicker.set('onDayCreate', (dObj, dStr, fp, dayElem) => {
            const date = moment(dayElem.dateObj).format('YYYY-MM-DD');

            // Highlight dates with events
            if (selectedDays.includes(date)) {
                dayElem.className += " dayEvent";
            }

            // Highlight the currently selected date
            if (this.filterState.date && this.filterState.date.full) {
                const date1 = moment(this.filterState.date.full).format('YYYY-MM-DD');
                const selectDate = this.datePicker.selectedDates && this.datePicker.selectedDates.length > 0
                    ? moment(this.datePicker.selectedDates[0]).format('YYYY-MM-DD')
                    : null;

                if (selectDate && selectDate === date1 && new Date(date).getTime() === new Date(date1).getTime()) {
                    dayElem.className += " selected";
                }
            }
        });
    }

       /**
     * Updates the filters view by showing tags, adding event listeners, and updating URL parameters.
     * Shows tags in the view based on the current filter state, adds event listeners for filter tags,
     * and updates the URL parameters with the latest filter settings.
     */
    updateFiltersView = () => {
        const params = getParamsObjFromState(this.filterState)
        // Show tags in the view based on the current filter state
        showTags(this.filterState.filters);

        // Add event listeners for filter tags after rerender
        this.tagsEventListener();

        // Update URL parameters with the latest filter settings
        updateUrlParams(params);
    }

    checkNextMonthBtn() {
        const nextBtn = document.querySelector('.flatpickr-next-month');
        const numInput = document.querySelector('.numInputWrapper .numInput')
        if (nextBtn && nextBtn.classList.contains('flatpickr-disabled')) {
            numInput.classList.add('next-disabled')
        } else {
            numInput.classList.contains('next-disabled') && numInput.classList.remove('next-disabled')
        }
    }


    pageClick(e: Event) {
        const target = e.target as HTMLElement;
        // console.log('pageClick: ', target);
        const hasFcEventClass = target.classList.contains('fc-event');
        const hasEventModalTriggerInside = target.querySelector('[data-a11y-dialog-show="Event_modal"]') !== null;
        if (
            target.matches('[data-a11y-dialog-show="Event_modal"]') ||
            (hasFcEventClass && hasEventModalTriggerInside)
        ) {
            this.handleEventModalClick(target);
        }
        else if (target.matches('[data-calendar-id]')) {

            const filterId = target.getAttribute('data-calendar-id');
            updateFilterCalendarState(this.filterState.filters, [Number(filterId)])

            // Update Filter calendars checked inpunts
            updateCalendarView(this.filterState.filters)
            
            // Update filters view
            this.updateFiltersView();

            // Reset filtered events array and filter events based on the new parameters
            this.events.filtered = [];
            const params = getParamsObjFromState(this.filterState)
            this.events.all.forEach(event => {
                matchesFilters(event, params) && this.events.filtered.push(event);
            });
            // Update fpDatepicker markers 
            this.addDatepickerMarkers(this.events.filtered);

            // Update fullCalendar
            this.fullCalendar.updateEventSource(this.events);
            this.fullCalendar.renderCalendar();
           
        }
    }
    private handleEventModalClick(target: HTMLElement) {
        let eventId: string | null = null;

        if (target.hasAttribute('data-event-id')) {
            eventId = target.getAttribute('data-event-id');
        } else {
            const childWithEventId = target.querySelector('[data-event-id]');
            if (childWithEventId) {
                eventId = childWithEventId.getAttribute('data-event-id');
            }
        }

        const newContents = document.querySelector(`[data-modal-contents="${eventId}"]`) as HTMLElement;

        // Update event modal content area and show the modal
        this.eventModalContentArea.innerHTML = newContents.innerHTML;
        this.eventModal.modal.show();
    }

    private eventSearch() {
        const searchInput: HTMLInputElement = document.getElementById('eventSearchInput') as HTMLInputElement;
        const searchForm: HTMLFormElement = document.getElementById('searchEventsForm') as  HTMLFormElement;
        searchInput.removeEventListener('input', () => { });
        searchForm.removeEventListener('submit', () => { });
        const autocompleteSearch = document.getElementById('autocompleteSearch');
    
        searchForm.addEventListener('submit', (event) => {
            event.preventDefault();
            this.searchEvents = searchInput.value;
            let listView;
            if (this.searchEvents.length === 0) {
                const searchForm = document.getElementById('searchEventsForm');
                //@ts-ignore
                searchForm.reset();
                listView = 'listMonth'
            } else {
                 listView = 'listAllYears';               
            }

            // Filter events based on updated parameters
            const filteredEvents = this.events.all.filter(event => matchesFilters(event, getParamsObjFromState(this.filterState)));

            // Filter events based on search events input
            this.events.filtered = this.checkSearchEvents(filteredEvents, this.searchEvents);

            // Update datePicker markers
            this.addDatepickerMarkers(this.events.filtered)

            // Update fullCalendar
            const dateToCalendar = this.filterState.date && this.filterState.date.full
                ? this.filterState.date.full
                : new Date(this.datePicker.currentYear, this.datePicker.currentMonth);


            this.fullCalendar.updateEventSource(this.events);
            this.fullCalendar.calendarView(listView, dateToCalendar);
            this.fullCalendar.renderCalendar();
            this.fullCalendar.showInfoMessage();
            this.hideAutocompletePanel('autocompleteSearch');
        })
        searchInput.addEventListener('input', (event) => {
            autocompleteSearch.innerHTML = '';
            let searchedEvents: string[] = [];
            if (searchInput.value !== '') {
                const filteredEvents = [];

                const params = getParamsObjFromState(this.filterState)
                this.events.all.forEach(event => {
                    matchesFilters(event, params) && filteredEvents.push(event);
                });

                filteredEvents.forEach(event => {
                    const eventName = event.title.split(' ').filter(c => c.length > 0).join(' ');
                    const searchText = searchInput.value.split(' ').filter(c => c.length > 0).join(' ');
                    if (eventName.toLowerCase().includes(searchText.toLowerCase())) {
                        if (!searchedEvents.some(title => title.toLowerCase() === eventName.toLowerCase())) {
                            searchedEvents.push(eventName);
                        }
                    }
                })
            } else {
                searchedEvents = [];
                this.hideAutocompletePanel('autocompleteSearch');
            }

            if (searchedEvents.length > 0) {
                searchedEvents.forEach(title => {
                    const el = document.createElement('div');
                    el.classList.add('autocompleteItem')
                    el.textContent = title;
                    autocompleteSearch.appendChild(el)
                    el.addEventListener('click', (event) => {
                        searchInput.value = event.target['textContent'];
                        this.hideAutocompletePanel('autocompleteSearch');
                        (searchForm.querySelector('.search-button') as HTMLButtonElement).click();

                    })
                })
                autocompleteSearch.classList.remove('visually-hidden')

            } else {
                this.hideAutocompletePanel('autocompleteSearch');
            }
            const resetButton = document.getElementById('resetEventSearch');
            resetButton.style.visibility = event.target['value'] ? 'visible' : 'hidden';
        })
  
    }
    private resetEventSearch() {
        const resetBtn = document.getElementById('resetEventSearch');
        resetBtn.addEventListener('click', () => {
            const searchForm = document.getElementById('searchEventsForm');
            //@ts-ignore
            searchForm.reset();
            this.searchEvents = '';
            resetBtn.style.visibility = 'hidden';
            this.hideAutocompletePanel('autocompleteSearch');


            if (this.fullCalendar.getViewMode() === 'listAllYears') {
                // Filter events based on updated parameters
                this.events.filtered = this.events.all.filter(event => matchesFilters(event, getParamsObjFromState(this.filterState)));

                /// Filter events based on search events input
                //this.events.filtered = this.checkSearchEvents(this.events.filtered, this.searchEvents);

                // Update datePicker markers
                this.addDatepickerMarkers(this.events.filtered)

                // Update fullCalendar
                const dateToCalendar = this.filterState.date && this.filterState.date.full
                    ? this.filterState.date.full
                    : new Date(this.datePicker.currentYear, this.datePicker.currentMonth);

                this.fullCalendar.calendarView('listMonth', dateToCalendar);
                this.fullCalendar.updateEventSource(this.events);
                this.fullCalendar.showInfoMessage();
            }

        })
    }
    private checkSearchEvents(filteredEvents: CalendarEvent[], searchStr: string | null): CalendarEvent[] {
        if (searchStr && searchStr.length > 0) {
            return filteredEvents.filter(event => event.extendedProps.eventTitle.toLowerCase().includes(searchStr.toLowerCase()))
        }
        return filteredEvents;
    }

    hideAutocompletePanel(panelId: string) {
        const autocompleteSearch = document.getElementById(panelId);
        !autocompleteSearch.classList.contains('visually-hidden') && autocompleteSearch.classList.add('visually-hidden')
    }
}

